import type { ErrorReason, Status } from '@paypalcorp/ppclientinteractions';

import { CI } from '../ci';
import { useOnceSync } from './useOnceSync';
import type { CustomerInteraction } from '../constants';

interface EndAndStartParams {
  end: CustomerInteraction;
  endStatus?: Status;
  endReason?: ErrorReason;
  start: CustomerInteraction;
}

/**
 * Ends a Customer Interaction and starts a new one during mount
 */
export function useEndAndStartCi({
  endReason,
  endStatus,
  end,
  start,
}: EndAndStartParams): void {
  useOnceSync(() => {
    if (endStatus) {
      CI.endWith(end, endStatus, endReason);
    } else {
      CI.end(end);
    }

    CI.start(start);
  });
}
